import { Participant } from '../../components/diagram-canvas/models/participant.class';
import { HALF_PARTICIPANT_WIDTH, LIFELINE_DASH_PATTERN } from '../../components/diagram-canvas/constants';
import { Injectable } from '@angular/core';
import { ACTOR_LIFELINE_Y } from '../../components/diagram-canvas/constants';
import { ENTITY_LIFELINE_Y } from '../../components/diagram-canvas/constants';

@Injectable({ providedIn: 'root' })
export class LifelineDrawerService {
  drawLifeLines(ctx: CanvasRenderingContext2D, participants: Participant[], maxHeight: number): void {
    ctx.setLineDash(LIFELINE_DASH_PATTERN);

    participants.forEach(p => {
      let centerX: number;

      if (p.type === 'entity') {
        const textWidth = ctx.measureText(p.name).width;
        const boxWidth = Math.max(100, textWidth + 20);
        centerX = p.x + boxWidth / 2;
      } else {
        centerX = p.x + HALF_PARTICIPANT_WIDTH;
      }

      const startY = p.y + (p.type === 'actor' ? ACTOR_LIFELINE_Y : ENTITY_LIFELINE_Y);
      ctx.beginPath();
      ctx.moveTo(centerX, startY);
      ctx.lineTo(centerX, maxHeight);
      ctx.stroke();
    });

    ctx.setLineDash([]);
  }
}
